import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomerForm from '../components/customers/CustomerForm';
import { useData } from '../contexts/DataContext';
import { Box } from '@mui/material';

export default function EditCustomer() {
  const location = useLocation();
  const navigate = useNavigate();
  const { updateCustomer } = useData();
  const customerData = location.state?.customerData;

  if (!customerData) {
    navigate('/customers');
    return null;
  }

  const handleSubmit = (updatedCustomer) => {
    updateCustomer(customerData.id, updatedCustomer);
    navigate(`/customers/${customerData.id}`);
  };

  return (
    <Box sx={{ p: 3 }}>
      <CustomerForm 
        initialData={customerData}
        onSubmit={handleSubmit}
      />
    </Box>
  );
} 